import React, {useEffect, useState} from 'react';
import moment from "moment";

import {Tabs} from "./components/Tabs";
import {TablePlayer} from './components/TablePlayer'

export const Rank = (props) => {
    const {rankData, onClickTab, leagueId, type} = props;
    const tabs = [
        {
            league_id: 1,
            type: 'batters',
            name: 'セ・リーグ打撃成績'
        },
        {
            league_id: 1,
            type: 'pitchers',
            name: 'セ・リーグ投手成績'
        },
        {
            league_id: 2,
            type: 'batters',
            name: 'パ・リーグ打撃成績'
        },
        {
            league_id: 2,
            type: 'pitchers',
            name: 'パ・リーグ投手成績'
        },
    ];
    const [activeIndexTab, setActiveIndexTab] = useState(0);
    const updatedat = rankData.reduce((prev, current) => {
        return prev ? prev : current.players.length > 0 ? current.updated_at : '';
    }, '');
    useEffect(() => {
        const idx = tabs.findIndex(item => item.league_id === leagueId && type === item.type);
        if (idx !== -1) {
            setActiveIndexTab(idx);
        }
        return;
    }, [leagueId, type])
    return (
        <div className='rank-container'>
            <h3>LIVEランキング
            {
                updatedat !== ''  ? (
                    <span className='date-match'>{moment(updatedat).format('YYYY/MM/DD HH:mm')} 更新</span>
                ) : (<></>)
            }
            </h3>
            <div className='contain'>
                <Tabs onTabClick={onClickTab} menu={tabs} activeTab={activeIndexTab}/>
                <div className='group-table-players'>
                    {
                        rankData.map(item => <TablePlayer dataTable={item}/>)
                    }
                </div>
            </div>
        </div>
    );
}
